import { CloudRain } from "lucide-react";

const LV = { warning: "border-rose-500/50 text-rose-300", watch: "border-sky-400/50 text-sky-300" };

// Model-forecast rainfall along each active hurricane cone (Open-Meteo ECMWF + GFS). Never scored.
export const StormRainOutlook = ({ storms = [] }) => {
  const rows = storms.filter((s) => s.rain_outlook?.towns?.length);
  if (!rows.length) return null;
  return (
    <div className="px-3 py-2 border-b border-white/10 bg-sky-500/[0.04]" data-testid="storm-rain-outlook">
      <div className="flex items-center justify-between mb-1">
        <span className="flex items-center gap-1.5 text-[10px] font-mono uppercase tracking-widest text-sky-300">
          <CloudRain className="w-3.5 h-3.5" /> Hurricane rain outlook · 72 h
        </span>
        <span className="text-[9px] font-mono text-atlas-secondary">Model forecast · not scored</span>
      </div>
      {rows.map((s) => {
        const ro = s.rain_outlook;
        const flagged = ro.towns.filter((t) => t.level);
        return (
          <div key={s.id} className="mb-1" data-testid={`rain-outlook-${s.id}`}>
            <div className="text-[11px] text-white">
              {s.classification_label} {s.name}
              <span className="text-[10px] font-mono text-atlas-secondary"> · {ro.warning} warning · {ro.watch} watch · wettest {ro.towns[0].name} {Math.round(ro.towns[0].mm_72h)} mm</span>
            </div>
            {flagged.length > 0 && (
              <div className="flex flex-wrap gap-1 mt-1">
                {flagged.slice(0, 8).map((t) => (
                  <span key={t.name} className={`px-1.5 h-5 inline-flex items-center border text-[9px] font-mono uppercase tracking-wider ${LV[t.level]}`}
                    title={`ECMWF ${t.ecmwf_mm ?? "—"} mm · GFS ${t.gfs_mm ?? "—"} mm (72 h). Watch ≥ ${ro.watch_mm} mm, Warning ≥ ${ro.warning_mm} mm.`}
                    data-testid={`rain-town-${s.id}-${t.name}`}>
                    {t.name} · {Math.round(t.mm_72h)} mm · {t.level}
                  </span>
                ))}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};
